module.exports = __webpack_public_path__ + "static/media/link.e8b5197f.svg";